<template>
  <div class="mb-1">
    <label v-if="showLabel" for="">{{$t('chooseCurrency')}}</label>
    <v-select v-model="currency" :options="currencies" :clearable="false" @option:selected="emitToParent">
      <template #option="data">
        <div class="">
          <div class="pl-1">
            {{ data.label }}
          </div>
        </div>
      </template>
      <template #no-options>
        <div>
          {{ $t('sorryNoMatchingOptions') }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import API from './api';

  export default {
    name: 'SelectCurrency',
    components: {
      vSelect
    },
    props: {
      currencyCode: {
        type: String,
        default: 'XAF'
      },
      showLabel: {
        type: Boolean,
        default: true
      }
    },
    data(){
      return {
        currencies: [{label: 'XAF', value: 'XAF'}],
        currency: ''
      }
    },
    mounted(){
      if(this.currencyCode != 'XAF'){
        this.currency = {label: this.currencyCode, value: this.currencyCode};
        this.currencies.unshift(this.currency);
      }else{
        this.currency = this.currencies[0];
      }
      this.getCurrencies();
    },
    methods: {
      emitToParent(data){
        this.$emit('currency-changed', data.value);
      },
      getCurrencies(){
        API.getCurrencies().then(res=>{
          if(res.success){
            const currencies = res.data.map(item=>{
              item = {
                label: item,
                value: item
              }
              return item;
            });
            if(currencies.length){
              this.currencies = currencies;
            }
          }
        }).catch(er=>{
          console.log(er);
        })
      }
    }
  }
</script>
